import React, { FC } from 'react';
import { Box, Checkbox, Text } from '@bechtel/gds';
import { FieldArray, FieldProps } from 'formik';
import { findIndex, some, map } from 'lodash';
import { ListSelectionStyled, DrawerSubHeaderStyled, SubListSelectionStyled, useTwxEnabled } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';
import { getVisibleWeldStatusList } from '../form-state';
import { useLingui } from '@lingui/react';

export const WeldStatusList: FC<FieldProps> = ({ form }) => {
  const { i18n } = useLingui();
  const { twxEnabled } = useTwxEnabled();
  const weldStatusList = getVisibleWeldStatusList(twxEnabled);

  return (
    <Box flexDirection={{ sm: 'column' }} data-testid="weld-status-container">
      <DrawerSubHeaderStyled>
        <Trans>Status</Trans>
      </DrawerSubHeaderStyled>
      <SubListSelectionStyled
        data-testid="weld-status-all"
        onClick={() => {
          if (form.values.weldStatusList?.length !== weldStatusList.length) {
            form.setFieldValue('weldStatusList', map(weldStatusList, 'value'));
          } else {
            form.setFieldValue('weldStatusList', []);
          }
        }}
      >
        <Box alignItems={{ sm: 'center' }}>
          <Box mr={{ sm: '500' }}>
            <Checkbox
              checked={form.values.weldStatusList?.length === weldStatusList.length}
              indeterminate={
                form.values.weldStatusList?.length > 0 && form.values.weldStatusList?.length < weldStatusList.length
              }
              readOnly
            />
          </Box>
          <Text size="400" weight="600" color="bechtel.grey.1000">
            <Trans>Select All</Trans>
          </Text>
        </Box>
        {form.values.weldStatusList && form.values.weldStatusList.length > 0 && (
          <Text size="400" color="bechtel.grey.1000" data-testid="weld-status-selected-length">
            {form.values.weldStatusList.length} <Trans>Selected</Trans>
          </Text>
        )}
      </SubListSelectionStyled>
      <FieldArray name="weldStatusList">
        {(arrayHelpers) => {
          return (
            <>
              {weldStatusList.length > 0 &&
                weldStatusList.map((weldStatusItem) => {
                  return (
                    <ListSelectionStyled
                      key={weldStatusItem.id}
                      data-testid={`weld-status-item-${weldStatusItem.id}`}
                      onClick={() => {
                        const selected = findIndex(form.values.weldStatusList, (item) => {
                          return item === weldStatusItem.value;
                        });
                        if (selected !== -1) {
                          arrayHelpers.remove(selected);
                        } else {
                          arrayHelpers.push(weldStatusItem.value);
                        }
                      }}
                    >
                      <Box mr={{ sm: '500' }}>
                        <Checkbox
                          checked={some(form.values.weldStatusList, (item) => {
                            return item === weldStatusItem.value;
                          })}
                          readOnly
                        />
                      </Box>
                      <Text size="400" color="bechtel.grey.1000">
                        {i18n._(weldStatusItem.label)}
                      </Text>
                    </ListSelectionStyled>
                  );
                })}
            </>
          );
        }}
      </FieldArray>
    </Box>
  );
};
